/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

const contentStyles = css`
  min-width: 280px;
  max-height: 340px;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-bottom: 44px;
`

const headerStyles = css`
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f9fafb;
`

const headerTitle = css`
  font-weight: 600;
  color: #0b2b45;
`

const bodyStyles = css`
  flex-grow: 1;
  padding: 16px;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const footerStyles = css`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  background-color: #fafafa;
  border-top: 1px solid #e0e0e0;
`

const cancelButton = css`
  color: #555;
  text-transform: none;
`

const confirmButton = css`
  text-transform: none;
  background-color: #0b2948;
  &:hover {
    background-color: #0a223e;
  }
`
export {
  contentStyles,
  headerStyles,
  headerTitle,
  bodyStyles,
  footerStyles,
  cancelButton,
  confirmButton,
}
